<template>
  <div class="text-neutral-300">
    <a
      v-if="isAuthorized"
      @click="logout"
      class="cursor-pointer text-sm underline"
      >Uitloggen</a
    >
    <form @submit.prevent="login" v-else class="flex items-center gap-2">
      <input
        ref="passwordInput"
        v-if="showInput"
        v-model="password"
        @keydown.esc="reset"
        required
        type="password"
        class="rounded-lg bg-neutral-100 px-2 py-0 text-black outline-none transition-all"
        :class="{
          '!bg-red-400 !text-white': passwordInvalid,
        }"
      />

      <a v-else @click="showInput = true"><KeyIcon class="w-5 py-1" /></a>
    </form>
  </div>
</template>

<script setup lang="ts">
  import { KeyIcon } from '@heroicons/vue/16/solid'
  import { nextTick, ref, useTemplateRef, watch } from 'vue'

  const emit = defineEmits(['set:authorized'])
  const showInput = ref(false)
  const password = ref('')
  const passwordInput = useTemplateRef('passwordInput')
  const passwordInvalid = ref(false)

  const reset = () => {
    showInput.value = false
    password.value = ''
  }

  watch(showInput, (bool) => {
    if (bool) {
      nextTick(() => {
        passwordInput.value?.focus()
      })
    }
  })

  defineProps<{ isAuthorized: boolean }>()

  const logout = async () => {
    await fetch('/auth/status', { method: 'DELETE' })
    checkIsAuthorized()
  }

  const login = async () => {
    const body = JSON.stringify({ password: password.value })
    const resp = await fetch('/auth', { method: 'POST', body })

    password.value = ''

    if (resp.ok) {
      showInput.value = false
      checkIsAuthorized()
    } else {
      passwordInvalid.value = true
      setTimeout(() => (passwordInvalid.value = false), 1500)
    }
  }

  const checkIsAuthorized = async () => {
    const resp = await fetch('/auth/status', { credentials: 'include' })
    const data = (await resp.json()) as { isAuthorized: boolean }
    emit('set:authorized', data.isAuthorized)
  }

  checkIsAuthorized()
</script>
